import { AllGradingMonitoringResponseModel, DeheadingQaQcDto } from "@gtpl/shared-models/production-management";
import { EntityRepository, Repository } from "typeorm";
import { GradeInventoryIdRequest } from "../dto/grad-inv-id-req";
import { GradingMonitoring } from "../entities/grading-monitoring.entity";

@EntityRepository(GradingMonitoring)
export class GradeMonitoringRepository extends Repository<GradingMonitoring> {

    async getSamplesInfoByGrdInvId(req: GradeInventoryIdRequest): Promise<GradingMonitoring> {
        try {
            const logInfo = await this.createQueryBuilder('grading_monitoring')
                .where(`grad_inv_id='${req.gradeInventoryId}'`)
                .getOne();
            return logInfo
        } catch (error) {
            return error
        }
    }
}